import { SxProps, Theme } from '@mui/material'
import * as React from 'react'
import LoginIcon from '@mui/icons-material/Login'
import LogoutIcon from '@mui/icons-material/Logout'
import BookOnlineIcon from '@mui/icons-material/BookOnline'
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts'
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'

export const NAV_SX_PROP: Record<string, SxProps<Theme>> = {
  '/register': { mr: 2, ml: 2 },
  '/login': {},
  '/logout': { ml: 2 },
  '/portal': { ml: 2 },
  '/admin': { ml: 2 },
}

export const NAV_ICON_PROP: Record<string, React.ReactNode> = {
  '/register': <BookOnlineIcon />,
  '/login': <LoginIcon />,
  '/logout': <LogoutIcon />,
  '/portal': <ManageAccountsIcon />,
  '/admin': <AdminPanelSettingsIcon />,
}

export const NAV_COLOR_PROP: Record<
  string,
  'inherit' | 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning'
> = {
  '/register': 'info',
  '/login': 'info',
  '/logout': 'error',
  '/portal': 'success',
  '/admin': 'success',
}
